import { Route, Switch, useRouteMatch } from 'react-router'
import { makeChildRoute } from '../../utils/CreateChildRoute'
import { updateBreadcrumbs } from '../Organization/Administration/Breadcrumbs'
import { TandemAccountPage } from './TandemAccountPage'
import { TandemPage } from './TandemPage'

export const TandemRouter = () => {
	const { path } = useRouteMatch()

	updateBreadcrumbs(`/_administration/_tandem`, 'Tandem')

	return (
		<Switch>
			<Route path={makeChildRoute(':accountId', path)}>
				<TandemAccountPage />
			</Route>
			<Route path={makeChildRoute('', path)}>
				<TandemPage />
			</Route>
		</Switch>
	)
}
